import { createBrowserRouter, Navigate } from 'react-router-dom';

import GroupsPage from './pages/GroupsPage';
import AuthPage from './pages/AuthPage';
import PhoneAuthPage from './pages/PhoneAuthPage';
import CreateGroupPage from './pages/CreateGroupPage';
import GroupDetailPage from './pages/GroupDetailPage';
import AddExpensePage from './pages/AddExpensePage';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import EditExpensePage from './pages/EditExpensePage';
import PrivacyPage from './pages/PrivacyPage';
import ProfilePage from './pages/ProfilePage';
import { KakaoCallbackPage } from './pages/KakaoCallbackPage';
import { getAuthToken } from './lib/client';
import { EditGroupPage } from './pages/EditGroupPage';
import FaqPage from './pages/FaqPage';
import LinkKakaopayPage from './pages/LinkKakaopayPage';
import DeleteInfo from './pages/Delete-Info';
import MobileRedirectPage from './pages/MobileRedirectPage.tsx';
import { LedgerPage } from './pages/LedgerPage.tsx';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

// eslint-disable-next-line react-refresh/only-export-components
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = getAuthToken();

  if (!token) {
    return <Navigate to="/auth" replace />;
  }

  
  return <>{children}</>;
}; 

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'groups/:id',
        element: <GroupDetailPage />,
      },
      {
        path: 'auth',
        element: <AuthPage />,
      },
      {
        path: 'auth/phone',
        element: <PhoneAuthPage />,
      },
      {
        path: 'privacy',
        element: <PrivacyPage />,
      },
      {
        path: 'auth/kakao-callback',
        element: <KakaoCallbackPage />,
      },
      {
        path: 'mobile',
        element: <ProtectedRoute><MobileRedirectPage /></ProtectedRoute>,
      },
      {
        path: 'groups',
        element: <ProtectedRoute><GroupsPage /></ProtectedRoute>,
      },
      {
        path: 'groups/create',
        element: <ProtectedRoute><CreateGroupPage /></ProtectedRoute>,
      },
      {
        path: 'groups/:id/ledger',
        element: <ProtectedRoute><LedgerPage /></ProtectedRoute>,
      },
      {
        path: 'groups/:id/edit',
        element: <ProtectedRoute><EditGroupPage /></ProtectedRoute>,
      },
      {
        path: 'groups/:id/add-expense',
        element: <ProtectedRoute><AddExpensePage /></ProtectedRoute>,
      },
      {
        path: 'groups/:id/edit-expense/:expenseId',
        element: <ProtectedRoute><EditExpensePage /></ProtectedRoute>,
      },
      {
        path: 'profile',
        element: <ProtectedRoute><ProfilePage /></ProtectedRoute>,
      },
      {
        path: 'profile/link-kakaopay',
        element: <ProtectedRoute><LinkKakaopayPage /></ProtectedRoute>,
      },
      {
        path: 'faq',
        element: <ProtectedRoute><FaqPage /></ProtectedRoute>,
      },
      {
        path: 'delete-info',
        element: <ProtectedRoute><DeleteInfo /></ProtectedRoute>,
      },
    ],
  },
]);
